import React, { useState, useContext, useEffect } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import errorToast from "helpers/errorToast";
import CardNew from "components/molecules/Card/CardNew";
import { getLocationAnalytics } from "api";
import Dropdown from "components/atoms/Dropdown/Dropdown";
import BarChart from "../BarChart";
import GraphDateFilter from "../GraphDateFilter";
import GraphGroupFilter from "../GraphGroupFilter";
import AnalyticsContext from "../analyticsContext";
import ChartModeSwitch from "../ChartModeSwitch";
import DateHeaderTable from "../DateHeaderTable";

function Location() {
  const intl = useIntl();
  const { params } = useContext(AnalyticsContext);

  const [totalSpentData, setTotalSpentData] = useState(null);
  const [shipmentData, setShipmentData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [hasData, setHasData] = useState(true);
  const [tabValue, setTabValue] = useState("1");

  const searchParams = new URLSearchParams(window.location.search);
  const report = searchParams.get("report");

  const tabs = [
    {
      label: intl.formatMessage({
        id: "general.amount",
        defaultMessage: "Amount",
      }),
      value: "1",
    },
    {
      label: intl.formatMessage({
        id: "general.count",
        defaultMessage: "Count",
      }),
      value: "2",
    },
  ];

  const getFreightModeData = () => {
    setIsLoading(true);
    getLocationAnalytics({ params })
      .then((res) => {
        if (
          Object.keys(res.data.total_spent_data.content).length === 0 ||
          Object.keys(res.data.shipment_data.content).length === 0
        ) {
          setTotalSpentData(null);
          setShipmentData(null);
          setHasData(false);
        } else {
          setTotalSpentData(res.data.total_spent_data);
          setShipmentData(res.data.shipment_data);
          setHasData(true);
        }
        setIsLoading(false);
      })
      .catch((err) => errorToast(err));
  };

  useEffect(() => getFreightModeData(), [params]);

  useEffect(() => {
    if (report) {
      setTabValue("2");
    }
  }, [report]);

  return (
    <>
      <CardNew className="border-radius-top-0">
        <div className="d-flex justify-content-between flex-wrap">
          <div className="mb-xs-2" style={{ width: "140px", display: "inline-block" }}>
            <div className="mb-2">
              <FormattedMessage id="general.report" defaultMessage="Report" />
            </div>
            <Dropdown options={tabs} onChange={(item) => setTabValue(item.value)} defaultValue={report ? "2" : "1"} />
          </div>
          <div className="d-flex flex-wrap">
            <ChartModeSwitch />
            <GraphDateFilter />
            <GraphGroupFilter />
          </div>
        </div>
        <div>
          {!hasData && !isLoading && (
            <div className="d-flex flex-column align-items-center justify-content-center" style={{ height: "400px" }}>
              <h5>
                <FormattedMessage id="analytics.noData" defaultMessage="No data available" />
              </h5>
              <p className="text-secondary">
                <FormattedMessage id="analytics.changeFilters" defaultMessage="Please change the filters and try again." />
              </p>
            </div>
          )}
          {hasData && !isLoading && (
            <div style={{ width: "100%", marginTop: 30 }}>
              {totalSpentData && tabValue === "1" && (
                <BarChart
                  chartData={totalSpentData}
                  title={intl.formatMessage({
                    id: "analytics.totalSpentUSD",
                    defaultMessage: "Total Spent USD",
                  })}
                  displayCurrencySymbol
                />
              )}
              {shipmentData && tabValue === "2" && (
                <BarChart
                  chartData={shipmentData}
                  title={intl.formatMessage({
                    id: "analytics.numberOfShipments",
                    defaultMessage: "Number of Shipments",
                  })}
                />
              )}
            </div>
          )}
          {isLoading && (
            <div className="text-center d-flex align-items-center justify-content-center" style={{ height: "400px" }}>
              <div className="spinner-border text-primary" role="status" />
            </div>
          )}
        </div>
      </CardNew>

      {tabValue === "2" && shipmentData && (
        <DateHeaderTable isLoading={isLoading} chartData={shipmentData} className="mt-5" />
      )}
      {tabValue === "1" && totalSpentData && (
        <DateHeaderTable isLoading={isLoading} chartData={totalSpentData} className="mt-5" displayCurrencySymbol />
      )}
    </>
  );
}

export default Location;
